import PoolAttestations from "./components/pool/PoolAttestations";
import SinglePageLayout from "../../layout/SinglePageLayout";

const CaisseAttestations = () => {
    return (
        <>
            <SinglePageLayout>
                {
                    <PoolAttestations/>
                }
            </SinglePageLayout>
        </>
    )
}
export default CaisseAttestations